import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import todosReducer from './slices/todosSlice';
import agentReducer from './slices/agentSlice';
import credentialsReducer from './slices/credentialsSlice';
import testingReducer from './slices/testingSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    todos: todosReducer,
    agent: agentReducer,
    credentials: credentialsReducer,
    testing: testingReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ['persist/PERSIST'],
      },
    }),
});

export default store;
